import { render, staticRenderFns } from "./Confirmacion.vue?vue&type=template&id=71571d2a&"
import script from "./Confirmacion.vue?vue&type=script&lang=js&"
export * from "./Confirmacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports